import axiosApiInstanse from "./auth-request-api";
import axios from "axios";

import { auth } from "@/config/host.config";
import { IAuth, ILogin } from "@/@types/auth/auth";
import { AccessToken } from "../accessDecoder";
import { AxiosError, AxiosResponse } from "axios";

import { useAuthorizationStore } from "@/store/modules/authorization";
import { prepareCredentials, fetchChallenge, resetKeyCache } from "./rsa-crypto";

export const AuthAPI = {
  login(
    login: string,
    password: string,
    nonce?: string | null
  ): Promise<AxiosResponse<IAuth>> {
    const url = auth.login;
    const data: { login: string; password: string; nonce?: string } = {
      login,
      password,
    };
    if (nonce) data.nonce = nonce;
    return axios.post(url, data);
  },
  logout(): Promise<AxiosResponse<IAuth>> {
    const url = auth.logout;
    return axiosApiInstanse.post(url);
  },
  registrationTicket(serialNumber: string): Promise<AxiosResponse> {
    const url = auth.registration;
    const data = {
      serialNumber,
      device_type: "tablet",
    };
    return axios.post(url, data);
  },
};

const LOGIN_MAX_ATTEMPTS = 2;

function getErrorCode(error: AxiosError): string | undefined {
  const body = error.response?.data as { error?: string } | undefined;
  return body?.error;
}

export function onRegistrationTicket(serialNumber: string): Promise<AxiosResponse> {
  return AuthAPI.registrationTicket(serialNumber);
}

export async function onLogin(loginData: ILogin): Promise<IAuth> {
  for (let attempt = 0; attempt < LOGIN_MAX_ATTEMPTS; attempt++) {
    const nonce = await fetchChallenge();
    const credentials = await prepareCredentials(
      loginData.login,
      loginData.password,
      nonce
    );

    try {
      const loginRes = await AuthAPI.login(
        credentials.login,
        credentials.password,
        nonce
      );
      if (loginRes.status === 200) {
        const access = loginRes.data.access || "";
        const refreshtoken = loginRes.data.refreshtoken || "";
        const useAuth = useAuthorizationStore();
        useAuth.setTokens(access, refreshtoken);
        const payload = AccessToken.payload;
        if (payload) {
          useAuth.setLogin(loginData.login);
          return loginRes.data;
        } else {
          throw new Error("Invalid token payload");
        }
      } else {
        throw new Error(`Login failed with status: ${loginRes.status}`);
      }
    } catch (e) {
      const code = getErrorCode(e as AxiosError);
      const retryable =
        code === "nonce_invalid_or_used" ||
        code === "nonce_mismatch" ||
        code === "credentials_decrypt_error";
      if (attempt < LOGIN_MAX_ATTEMPTS - 1 && retryable) {
        if (code === "credentials_decrypt_error") {
          resetKeyCache();
        }
        continue; // повторный цикл → новый nonce и ключ
      }
      throw e;
    }
  }
  throw new Error("login failed after retries");
}
